import type { UseQueryOptions } from '@soundxyz/graphql-react-query/reactQuery';
import { useQuery } from '@soundxyz/graphql-react-query/reactQuery';
import { editionContractInfo } from '@soundxyz/sdk/contract/edition-v1/read/info';
import { assertAddress } from '@soundxyz/utils/address';
import { useChainProvider } from '@context/chainProvider';
import type { ContractType } from '@graphql/reactQuery';
import { SDK_KEY } from '../helpers';

type EditionInfo = Awaited<ReturnType<typeof editionContractInfo>>;

export function useEditionInfo<QueryData = EditionInfo>(
  {
    editionAddress,
    chainId,
    auctionContractType,
  }: { editionAddress: string; chainId: number; auctionContractType: ContractType | null },
  options?: Omit<UseQueryOptions<EditionInfo, Error, QueryData, string[]>, 'queryKey' | 'queryFn'>,
) {
  const { provider } = useChainProvider();

  const result = useQuery({
    queryKey: [SDK_KEY, 'edition-info', editionAddress, chainId.toString()],
    queryFn() {
      assertAddress(editionAddress);

      return editionContractInfo(provider(chainId), { editionAddress });
    },
    ...options,
    enabled: (options?.enabled ?? true) && auctionContractType === 'EDITION',
  });

  return result;
}
